/**
 * Typesafe assertion of an item to a class Instance
 * @param {S extends new (...args: unknown[]) => unknown} struct to assert the item is an instance of
 * @param {unknown} item to assert
 * @returns {InstanceType<S> | null}
 */
export const as = <S extends new (...args: unknown[]) => unknown>(
  struct: S,
  item: unknown,
): InstanceType<S> | null =>
  item instanceof struct ? (item as InstanceType<S>) : null;
